import { Typography } from '@thinknet-gmbh/platform-common-ui';
import { useTranslation } from 'react-i18next';

import { displayAddress, formatByMask } from 'src/common/helpers/common.helpers';
import { dateFormat } from 'src/common/helpers/date.helpers';
import { ICustomerData } from 'src/pages/customers/customers.interfaces';

import { InfoBlock, InfoElement, InfoWrapper } from './customer-details-info.styles';

const CustomerDetailsInfo = ({ data }: { data: ICustomerData }) => {
  const { t } = useTranslation(['common', 'customers']);

  return (
    <InfoWrapper>
      <InfoBlock>
        <InfoElement>
          <Typography weight="bold">{t('customers:labels.salutation')}:</Typography>
          <Typography>
            {data.salutation
              ? data.salutation.charAt(0) + data.salutation.slice(1).toLowerCase()
              : ''}
          </Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{t('customers:labels.customerName')}:</Typography>
          <Typography>{data.customerName || '-'}</Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{t('customers:labels.companyName')}:</Typography>
          <Typography>{data.companyName || '-'}</Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{t('common:labels.email')}:</Typography>
          <Typography>{data.email || '-'}</Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{t('common:labels.phoneNumber')}:</Typography>
          <Typography>{data.phoneNumber || '-'}</Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{t('customers:labels.mobilePhoneNumber')}:</Typography>
          <Typography>
            {formatByMask(data.mobilePhoneNumber, '+## ### ### #######') || '-'}
          </Typography>
        </InfoElement>
      </InfoBlock>
      <InfoBlock>
        <InfoElement>
          <Typography weight="bold">{t('common:labels.businessAddress')}:</Typography>
          <Typography>{displayAddress(data.address)}</Typography>
        </InfoElement>
        {data.contactPersons?.map(({ name, phoneNumber, email }, index) => (
          <div key={index}>
            <InfoElement>
              <Typography weight="bold">{t('customers:labels.contactPersonName')}:</Typography>
              <Typography>{name}</Typography>
            </InfoElement>
            <InfoElement>
              <Typography weight="bold">{t('customers:labels.contactPersonPhone')}:</Typography>
              <Typography>{formatByMask(phoneNumber, '+## ### ### #####')}</Typography>
            </InfoElement>
            <InfoElement>
              <Typography weight="bold">{t('customers:labels.contactPersonEmail')}:</Typography>
              <Typography>{email || '-'}</Typography>
            </InfoElement>
          </div>
        ))}
        <InfoElement>
          <Typography weight="bold">{t('customers:labels.dateOfAccountCreation')}:</Typography>
          <Typography>{dateFormat(data.createdAt)}</Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{t('customers:labels.notes')}:</Typography>
          <Typography>{data.notes || '-'}</Typography>
        </InfoElement>
      </InfoBlock>
    </InfoWrapper>
  );
};

export default CustomerDetailsInfo;
